var ApplicationItem;

import ApplicationUserModal from 'trunks/vue/admin/compositions/organization_modal/application_user_modal.js';

import UserItem from 'trunks/vue/admin/components/libs/user_item.js';

import ResponsiveItem from 'trunks/vue/admin/components/responsive_item.js';

export default ApplicationItem = {
  components: {
    'user-item': UserItem,
    'application-user-modal': ApplicationUserModal,
    'responsive-item': ResponsiveItem
  },
  props: {
    application: {
      type: Object
    },
    resources: {
      type: String
    },
    organization: {
      type: Object
    }
  },
  data: function() {
    return {
      profileSchema: null
    };
  },
  computed: {
    applicationTime: function() {
      return Date.parseFromString(new Date(this.application.created_at)).toTimeAgoString();
    },
    headers: function() {
      return {
        user: '姓名',
        identifier: '识别码/手机号'
      };
    },
    operations: function() {
      if (this.application.status === 'pending') {
        return [
          {
            type: 'approve',
            label: '通过',
            color: 'btn-primary'
          },
          {
            type: 'refuse',
            label: '拒绝',
            color: 'btn-danger'
          }
        ];
      } else if (this.application.status === 'approved') {
        return [
          {
            type: 'approved',
            label: '已通过',
            color: 'btn-default'
          }
        ];
      } else if (this.application.status === 'refused') {
        return [
          {
            type: 'refused',
            label: '已拒绝',
            color: 'btn-default'
          }
        ];
      }
    },
    toolTip: function() {
      return `${this.application.user.identifier}/${this.application.user.phone}`;
    }
  },
  template: `<responsive-item :headers="headers"
                 :item="application"
                 :operations="operations"
                 @operationClicked="operationClickedFunc">
  <template slot="cellInfo" slot-scope="{ attr }">
    <div class="application-user" v-if="attr == 'user'" @click="showUserInfoModal">
      <user-item :user="application.user"/>
    </div>
    <div  v-if="attr == 'identifier'">
      <div class="slp-tooltip top" :data-title="toolTip"></div>
      <div class="user-info" >{{ application.user.identifier }}/{{ application.user.phone }}</div>
    </div>
  </template>
  <template slot="operations">
    <template v-for="operation in operations">
      <button class="text-btn mr-2"
              :class="operation.color"
              @click="operationClickedFunc(operation)">{{ operation.label }}</button>
    </template>
    <button class="text-btn time">（{{ applicationTime }}）</button>
  </template>
</responsive-item>`,
  created: function() {
    return Skylark.Libs.Ajax.get("/admin/user_profile/schema.json", {
      responseType: 'json',
      success: (profileSchema) => {
        return this.profileSchema = profileSchema;
      }
    });
  },
  methods: {
    operationClickedFunc: function(operation) {
      if (operation.type === 'approve' || operation.type === 'refuse') {
        return this.statusChanged(operation.type);
      }
    },
    statusChanged: function(status) {
      return Skylark.Libs.Ajax.put(`${this.resources}/${this.application.id}/${status}`, {
        contentType: 'application/json, text/javascript',
        responseType: 'json',
        success: (res) => {
          this.application.status = `${status}d`;
          return this.$emit('statusChanged', this.application);
        },
        error: function() {
          return newAlertify('处理失败', {
            type: 'error'
          });
        }
      });
    },
    showUserInfoModal: function() {
      return new ApplicationUserModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('application_user_modal_container'),
        propsData: {
          application: this.application,
          applicationTime: this.applicationTime,
          organization: this.organization,
          profileSchema: this.profileSchema,
          statusChangeCallback: (status) => {
            return this.statusChanged(status);
          }
        }
      });
    }
  }
};
